// publicChatClient — talk to the pre-login public assistant endpoint.
// ---------------------------------------------------------------------------
// POSTs to {VITE_AGENT_URL}/agent/public-chat with NO auth token (it runs on
// the sign-in page). The backend is tool-less + PHI-guarded + rate-limited, so
// nothing here can reach protected data. Blank VITE_AGENT_URL → the widget uses
// its offline public engine (publicKnowledge.js) instead.

const AGENT_URL = (import.meta.env.VITE_AGENT_URL || '').replace(/\/$/, '');

export const isPublicBackendEnabled = () => Boolean(AGENT_URL);

/**
 * Ask the public assistant. Throws on transport/HTTP error so the caller can
 * fall back to the offline engine.
 * @returns {Promise<{ text, cta?, steps? }>}
 */
export async function publicChatViaBackend({ messages, signal }) {
  const res = await fetch(`${AGENT_URL}/agent/public-chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ messages }),
    signal,
  });
  if (!res.ok) {
    let detail = '';
    try { detail = (await res.json())?.error || ''; } catch { /* ignore */ }
    throw new Error(`${res.status} ${res.statusText}${detail ? ` — ${detail}` : ''}`);
  }
  const json = await res.json();
  return {
    text: json.answer || '',
    cta: json.cta || undefined,
    steps: Array.isArray(json.steps) ? json.steps : undefined,
    stepsTitle: json.stepsTitle || undefined,
  };
}
